import React from 'react';
import PropTypes from 'prop-types';

import { getUniquePageLoadId } from '@confluence/unique-page-load-id';
import { LoadablePaint } from '@confluence/loadable';
import { Screen } from '@confluence/screen';

const ExternalShareRouteComponent = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-ExternalShareRouteComponent" */ './ExternalShareRouteComponent'
		),
});

export const ExternalShareRoute = ({ name, params: { contentId, externalToken }, hash }) => (
	<Screen
		screenEvent={{
			name: 'viewPageScreen',
			id: contentId,
			attributes: {
				isPublicView: true,
				pageLoadInfo: getUniquePageLoadId(),
			},
		}}
		pageState={{
			contentId,
			routeName: name,
		}}
	>
		<ExternalShareRouteComponent
			siteUrl={window.location.hostname}
			contentId={contentId === 'undefined' ? undefined : contentId}
			shareToken={externalToken}
			queryHash={hash}
		/>
	</Screen>
);

ExternalShareRoute.propTypes = {
	name: PropTypes.string.isRequired,
	params: PropTypes.shape({
		contentId: PropTypes.string,
		externalToken: PropTypes.string,
	}),
	hash: PropTypes.string,
};
